import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output
} from '@angular/core';
import { CommentListService } from '@go-modules/services/comment-list/comment-list.service';
import { FeedbackSessionService } from '@go-modules/services/feedback-session/feedback-session.service';
import { COMMENT_RESOURCE_TYPES } from 'go-modules/models/comment/comment.constant';
import { map, Observable } from 'rxjs';
import { MediaDisplayMode } from 'go-modules/feedback-session/feedback-session.provider';
import { CommentViewerModule } from '../comment-viewer/comment-viewer.module';
import { FeedbackDisplayHeaderComponent } from '../feedback-display-header/feedback-display-header.component';
import { TranslateModule } from '@ngx-translate/core';
import { PlayerSync } from '@go-modules/interfaces/media/media';
import { Marker } from '@go-modules/interfaces/markers/marker';
import { NgxZeroStateModule } from '@go-modules/components/zero-state/zero-state.module';

@Component({
	selector: 'comment-sync-event-viewer',
	templateUrl: './comment-sync-event-viewer.component.html',
	styleUrls: ['./comment-sync-event-viewer.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		CommonModule,
		TranslateModule,
		CommentViewerModule,
		FeedbackDisplayHeaderComponent,
		NgxZeroStateModule
	]
})
export class CommentSyncEventViewerComponent implements OnInit, OnDestroy {
	@Input() public playerSync: PlayerSync;
	@Input() public tags: Marker[];
	@Output() public setMode: EventEmitter<MediaDisplayMode> = new EventEmitter();
	public hasSyncEventComments$: Observable<boolean> = this.commentListService.comments$.pipe(
		map((comments) => {
			return comments.some((comment) => {
				return comment.resource?.some((res) => res.resource_type === COMMENT_RESOURCE_TYPES.SYNC_EVENT);
			});
		})
	);

	constructor (
		private commentListService: CommentListService,
		private feedbackSessionService: FeedbackSessionService
	) {}

	public ngOnInit (): void {
		this.commentListService.toggleShowOnlySyncEventComments(true);
	}

	public ngOnDestroy (): void {
		this.commentListService.toggleShowOnlySyncEventComments(false);
	}

	public done = () => {
		this.feedbackSessionService.togglePanel(true);
		this.setMode.emit(MediaDisplayMode.PLAYBACK);
	};
};
